export default {"src":"/_next/static/media/OpenCorporates.598e65c0.svg","height":80,"width":80};